export default function getTemporaryUserMail() {
  return 'guest@livelinx.pro';
}
